import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const Devices = () => {
  const location = useLocation();
  const devicesData = location.state?.deviceInfos || [];
  const navigate = useNavigate();
  const { buildingId, bankId } = useParams();

  return (
    <div className="bg-[#0F172A] p-6 overflow-y-auto h-full w-full flex flex-col">
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate('/Buildings')} className="p-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
            </svg>
          </button>
          <div>
            <h1 className="text-2xl font-bold text-white">Devices</h1>
            <p className="text-sm text-slate-400 mt-1">{location.state?.buildingName || 'Building'} — {location.state?.bankName || 'Bank'}</p>
          </div>
        </div>

        <div className="bg-slate-800/60 border border-slate-700/50 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-700/50">
                  <th className="text-left py-3 px-5 text-xs font-semibold text-slate-400 uppercase tracking-wider">Device Name</th>
                  <th className="text-left py-3 px-5 text-xs font-semibold text-slate-400 uppercase tracking-wider">Device ID</th>
                  <th className="text-center py-3 px-5 text-xs font-semibold text-slate-400 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody>
                {devicesData && devicesData.length > 0 ? (
                  devicesData.map((device) => (
                    <tr key={device.id} className="border-b border-slate-700/30 hover:bg-slate-700/20 transition">
                      <td className="py-3 px-5 text-white font-medium">{device.deviceName}</td>
                      <td className="py-3 px-5 text-slate-300">{device.deviceId}</td>
                      <td className="py-3 px-5 text-center">
                        <button
                          onClick={() => {
                            if (buildingId) {
                              navigate(`/Buildings/${buildingId}/Banks/${bankId}/Devices/${device.deviceId}`, { state: { device: device } });
                            }
                          }}
                          className="px-3 py-1 bg-cyan-600 hover:bg-cyan-500 text-white text-xs font-semibold rounded-lg transition"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="py-8 text-center text-slate-500">No devices found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Devices;
